<div class="tire-size-different-recommended-dialog">
    <!-- header -->
    <div class="border-bottom-lightest flex-between-center flex-row tire-size-header">
        <div class="flex-end-center flex-row header-title">
            <i class="fa fa-exclamation-circle font-20 font-900 font-icon-color"></i>
            <span class="font-18 font-700 ml-2">Tire Size is different </span>
        </div>
        <i class="fal fa-times pointer font-20" (click)="handleClose()"></i>
    </div>
    <!-- body -->
    <div class="tire-size-body flex-column">
        <span class="font-16 font-400">Please make sure that the selected vehicle's tire size matches the size of the tires added to the cart</span>
        <div class="flex-row">
            <span class="font-16 font-600 p-1">Tire Size in cart:</span>
            <div class="flex-wrap flex-start-center">
                <div class="flex-center-center size-cart-pill pill-secondary" *ngFor="let tireSize of cartSizes">
                    <span class="font-14 font-600">{{tireSize?.label}}</span>
                </div>
            </div>
        </div>
        
        <div class="flex-row">
            <span class="font-16 font-600 p-1">Recommended tire sizes:</span>
            <div class="flex-wrap flex-start-center">
                <div class="flex-center-center size-cart-pill pill-primary" *ngFor="let recTireSize of recommendedSizes">
                    <span class="font-14 font-600">{{recTireSize?.label}}</span>
                </div>
            </div>
        </div>
        
    </div>
    <!-- footer -->
    <div class="tire-size-footer border-top-lightest flex-row flex-end-center">
        <button class="btn btn-border mr-1" (click)="handleClose()">
            Cancel
          </button>
      
          <button class="btn btn-primary" (click)="handleClose(true)">
            Proceed
          </button>
    </div>
</div>
